import { User } from './User.model';

export class GetUsersActivityAndTargetByCompanyResponse {
    users: User[];

    constructor(users: User[]) {
        this.users = users;
    }
}
